import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Menu , MenuItem , TextField , InputAdornment ,
  Icon ,Box
 } from "@mui/material";
 import SearchIcon from "@mui/icons-material/Search";
import "jspdf-autotable";
import io from "socket.io-client";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from 'moment-timezone';
import { API_ENDPOINTS, CUSTOM_CONSTANTS } from "Constants";
import DataTable from "react-data-table-component";
import LocationOnIcon from "@mui/icons-material/LocationOn";

//models
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Tripdetails";
import Cancelcurrentride from "Pages/Modals/Passengerhistory/Canceltheride"
//Services
import TriplistApi from "Services/Triplist";

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const timezone = useSelector((state) => state.timezone.timezone);
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(10); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchText, setSearchText] = useState("");
  const openaction = Boolean(anchorEl);
  const Tripstatus = ["SEARCHING", "CANCELLED", "COMPLETED", "SCHEDULED"];
  const Bookingtype = ["MOBILE APP", "WEB BOOKING", "STREET RIDE"];
  const Bookingtypevalue = ["MOBILE_APP", "WEB_BOOKING", "STREET_RIDE"];
  const [servicesData, setServicesData] = useState([]);
  const [filtervalues , setFiltervalues] = useState({});
  //Modals
  const [requestId, setrequestId] = useState("");
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const [cancelridemodel, setcancelrideModal] = useState(false);  
 // console.log('localStorage.getItem-->',`Bearer ${localStorage.getItem("token")}`);
 // console.log('localStorage.getItem-->',localStorage.getItem("userType"));
  const socket = io(CUSTOM_CONSTANTS.API_BASE_URL, {
    query: {
      authtoken: `Bearer ${localStorage.getItem("token")}`, // Replace with actual token
    },
   transports: ["websocket"],
   path: "/socket.io/",
  }); // Replace with your server URL

  useEffect(() => {
   dispatch(showLoader("Loading please wait..."));
    // Request all user ride requests
    const interval = setInterval(() => {
     // console.log('triggered-->')
    socket.emit("getAllUserRideRequests", { page, limit: pageSize , filtervalues });
  }, 5000);
    // Listen for trip list updates
    socket.on("tripListUpdated", (data) => {
      if (data.success) {
        dispatch(hideLoader());
      // console.log('data--->',data);
       setTotalPages(data?.data?.totalRecords || 1);
      //  console.log('res?.data?.data?.data--->',data?.data);
        setRow(data?.data?.data.triplists);
        setServicesData(data?.data?.data.serviceTypeDetails)
      }
      else{
        setRow([]);
      }
    });
    
    socket.on("loginStatus", (data) => {
      if (data.message) {
    //    console.log("Socket data-->", data); // Update table rows
      }
    });

    socket.on("disconnect", () => {
     // console.log("Socket disconnected");
    });
  
    // Cleanup socket connection
    return () => {
     clearInterval(interval);
      socket.off("tripListUpdated");
      socket.off("disconnect");
      
    };
  }, [page, pageSize , filtervalues]);

const handleopenCancelModel = (_id) => { 
  setrequestId(_id); 
  setcancelrideModal(true);
  setAnchorEl(null);
};

 const handlecloseCancelModel = () => {
  setcancelrideModal(false);
  socket.emit("getAllUserRideRequests", { page, limit: pageSize , filtervalues });
};

   const formatDate = (inputDate) => {
  if (!inputDate) return "--";

  const m = moment(inputDate);

  if (!timezone) {
    return m.format("YYYY-MM-DD hh:mm A");
  }

  return m.tz(timezone).format("YYYY-MM-DD hh:mm A");
};


  const handleOpenmoredetailsModal = (_id) => { 
    setrequestId(_id); 
    setmoredetailsModal(true);
    setAnchorEl(null);
 };

 const handleClosemoredetailsModal = () => {
  setmoredetailsModal(false);
};

  const filteredData = row.filter((data) => {
    return (
      data.bookingId?.toLowerCase().includes(searchText.toLowerCase()) ||
      formatDate(data.requestedAt)?.toLowerCase().includes(searchText.toLowerCase()) ||
      formatDate(data.startedAt)?.toLowerCase().includes(searchText.toLowerCase()) ||
      formatDate(data.completedAt)?.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.userdetails?.firstName} ${data.userdetails?.lastName}`.toLowerCase().includes(searchText.toLowerCase()) ||
      (data.driverdetails ? `${data.driverdetails.firstName} ${data.driverdetails.lastName}` : "Not Exists")
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      data.servicedetails?.serviceName.toLowerCase().includes(searchText.toLowerCase()) ||
      data.pickupAddress.toLowerCase().includes(searchText.toLowerCase()) ||
      data.dropAddress.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.tripDistance}`.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.estimatedFare}`.toLowerCase().includes(searchText.toLowerCase()) ||
      `${data.bookingType}`.toLowerCase().includes(searchText.toLowerCase()) ||
      data.cancelledBy.toLowerCase().includes(searchText.toLowerCase()) ||
      data.tripStatus.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const columns = [
    {
      name: "S.No",
      selector: (_, index) => index + 1 + (page - 1) * pageSize,
      sortable: false,
      width: "50px",
    },
    {
      name: "Booking ID",
      selector: (row) => row.bookingId,
      sortable: false,
      wrap: true,
      width: "80px",
      cell: (row) => (
        <Box
          onClick={() => handleOpenmoredetailsModal(row._id)}
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            cursor: "pointer",
            color: "#9c27b0", // Optional: Color to indicate it's clickable
          }}
        >
          <Typography variant="body2" style={{ fontSize: "12px",fontWeight: "bold" }} >{row.bookingId}</Typography>
          <LocationOnIcon style={{ fontSize: "16px" }} />
        </Box>
      ),
    },
    {
      name: "Booking Time",
      selector: (row) => formatDate(row.requestedAt),
      sortable: false,
      wrap: true,
      width: "110px",
    },
    {
      name: "Pickup Time",
      selector: (row) => formatDate(row.startedAt),
      sortable: false,
      wrap: true,
      width: "110px",
    },
    {
      name: "Drop Time",
      selector: (row) => formatDate(row.completedAt),
      sortable: false,
      wrap: true,
      width: "110px",
    },
    {
      name: "Passenger Name",
      selector: (row) => `${row.userdetails?.firstName || ""} ${row.userdetails?.lastName || ""}`,
      sortable: false,
      wrap: true,
      width: "100px",
    },
    {
      name: "Driver Name",
      selector: (row) =>
        row.driverdetails ? `${row.driverdetails.firstName} ${row.driverdetails.lastName}` : "Not Exists",
      sortable: false,
      wrap: true,
      width: "100px",
    },
    {
      name: "Service",
      selector: (row) => row.servicedetails?.serviceName,
      sortable: false,
      wrap: true,
      width: "100px",
    },
    {
      name: "Pickup Location",
      selector: (row) => row.pickupAddress,
      sortable: false,
      wrap: true,
      width: "130px",
    },
    {
      name: "Drop Location",
      selector: (row) => row.dropAddress,
      sortable: false,
      wrap: true,
      width: "130px",
    },
    {
      name: "Distance",
      selector: (row) => `${(row.tripDistance ?? 0).toFixed(2)} Km`,
      sortable: false,
      wrap: true,
      width: "80px",
    },
    {
      name: "Fare",
      selector: (row) => `${row.estimatedFare ?? 0} ${CUSTOM_CONSTANTS.BASE_CURRENCY}`,
      sortable: false,
      wrap: true,
      width: "80px",
    },
    {
      name: "Booking Type",
      selector: (row) => `${row.bookingType} (${row.userdetails?.device_type})`,
      sortable: false,
      wrap: true,
      width: "100px",
    },
    {
      name: "Cancelled By",
      selector: (row) => row.cancelledBy || "--",
      sortable: false,
      wrap: true,
      width: "70px",
    },
    {
      name: "Status",
      selector: (row) => row.tripStatus,
      sortable: false,
      wrap: true,
      width: "120px",
      cell: (row) => {
        const statusColors = {
          SEARCHING: "#f39c12",  // Orange
          CANCELLED: "#e12f2f",  // Red
          COMPLETED: "#5cb85c",  // Green
          STARTED: "#007bff",    // Blue
          DROPPED: "#6c757d",    // Grey
          ARRIVED: "#ff9800",    // Amber
          PICKEDUP: "#17a2b8",   // Teal
          READY: "#8e44ad",      // Purple
        };
    
   const isFinalStatus = row.tripStatus === "COMPLETED" || row.tripStatus === "CANCELLED";

    if (isFinalStatus) {
      return (
        <Typography
          variant="body2"
          style={{
            backgroundColor: statusColors[row.tripStatus] || "#ccc",
            color: "#fff",
            padding: "10px 7px",
            borderRadius: "5px",
            textAlign: "center",
            fontSize: "11px",
            display: "inline-block",
          }}
        >
          {row.tripStatus}
        </Typography>
      );
    } else {
      return (
        <button
          onClick={() => handleopenCancelModel(row._id)}
          style={{
            backgroundColor: statusColors[row.tripStatus] || "#007bff",
            color: "#fff",
            padding: "8px 10px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "11px",
          }}
        >
          {row.tripStatus}
        </button>
      );
    }

      },
    },
  ];

  // handle dates

const handlefromdate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("fromdate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("fromdate", formattedDate);
  }
};

const handletodate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("todate", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("todate", formattedDate);
  }
};

  // filter form 

  function convertToISO(inputDate) {
    if (!inputDate) {
      return "--"; // Handle null or undefined input
    }
  
    // Parse the input date string
    const date = new Date(inputDate);
  
    if (isNaN(date.getTime())) {
      return "--"; // Handle invalid date formats
    }
  
    // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
    const isoString = date.toISOString().replace("Z", "+00:00");
    return isoString;
  }
  
const handlefiltertriplist = (formValues) => {
  formValues.fromdate = convertToISO(formValues.fromdate);
  formValues.todate = convertToISO(formValues.todate);
 // console.log('formValues-->',formValues);
  dispatch(showLoader("Loading please wait..."));
  setFiltervalues(formValues);
 };

  const formik = useFormik({
    initialValues: {
      tripStatus: "",
      serviceTypeId: "",
      bookingType: "",
      fromdate: "",
      todate: "",
    },
    validationSchema: yup.object({
      fromdate: yup.string().required("From date is required").nullable(),
      todate: yup.string().required("To date is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlefiltertriplist(values); // Ensure this processes `values` correctly
    },
  });
  
  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid container className={classes.utilities}>

<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="tripStatus"
  id="tripStatus"
  select
  value={formik?.values?.tripStatus || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus
  }
  helperText={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus &&
    formik?.errors?.tripStatus
  }
  fullWidth
  variant="outlined"
  size="small"
  SelectProps={{
    displayEmpty: true, // Allows the placeholder to be visible when no value is selected
    renderValue: (selected) => (selected ? selected : "All Status"),
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start" sx={{ position: 'relative' }} >
        <img
          src="/assets/images/sidebar_icons/All Status.png"
          alt="sidebar_icons"
          width="35"
          height="30"
          style={{ pointerEvents: "none" }}
        />     
      </InputAdornment>
    ),
  }}
>
<MenuItem value="" >All Status</MenuItem>
{Tripstatus.map((status) => (
  <MenuItem key={status} value={status}>
    {status}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="serviceTypeId"
  id="serviceTypeId"
  select
  value={formik?.values?.serviceTypeId || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.serviceTypeId &&
    formik?.touched?.serviceTypeId
  }
  helperText={
    formik?.errors?.serviceTypeId &&
    formik?.touched?.serviceTypeId &&
    formik?.errors?.serviceTypeId
  }
  fullWidth
  variant="outlined"
  size="small"
  SelectProps={{
    displayEmpty: true, // Allows the placeholder to be visible when no value is selected
    renderValue: (selected) => 
      {
      if (!selected) return "All Services";
      const selectedService = servicesData.find(service => service._id === selected);
      return selectedService ? selectedService.serviceName : selected;
    },
      // (selected ? selected : "All Services"),
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start" sx={{ position: 'relative' }}>
        <img
          src="/assets/images/sidebar_icons/All Services.png"
          alt="sidebar_icons"
          width="35"
          height="30"
          style={{ pointerEvents: "none" }}
        />       
      </InputAdornment>
    ),
  }}
>
<MenuItem value="" >All Services</MenuItem>
  {servicesData.map((services) => (
  <MenuItem key={services._id} value={services._id}>
    {services.serviceName}
  </MenuItem>
  ))}
</TextField>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="bookingType"
  id="bookingType"
  select
  value={formik?.values?.bookingType || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.bookingType &&
    formik?.touched?.bookingType
  }
  helperText={
    formik?.errors?.bookingType &&
    formik?.touched?.bookingType &&
    formik?.errors?.bookingType
  }
  fullWidth
  variant="outlined"
  size="small"
  SelectProps={{
    displayEmpty: true, // Allows the placeholder to be visible when no value is selected
    renderValue: (selected) => 
      {
      if (!selected) return "All Booking type";
      const index = Bookingtypevalue.indexOf(selected);
      return index !== -1 ? Bookingtype[index] : selected;
    },
      //(selected ? selected : "All Booking type"),
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <img
          src="/assets/images/sidebar_icons/All Booking.png"
          alt="sidebar_icons"
          width="35"
          height="30"
          style={{ pointerEvents: "none" }}
        />
      </InputAdornment>
    ),
  }}
>
  <MenuItem value="">All Booking type</MenuItem>
  {Bookingtype.map((label, index) => (
    <MenuItem key={Bookingtypevalue[index]} value={Bookingtypevalue[index]}>
      {label}
    </MenuItem>
  ))}

{/* <MenuItem value="" >All Booking type</MenuItem>
{Bookingtype.map((booking) => (
  <MenuItem key={booking} value={booking}>
    {booking}
  </MenuItem> */}
</TextField>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
  <div className={classes.datePickerStyle}> 
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="From Date"
  value={formik?.values?.fromdate || ""}
  size="small"
  onChange={(newValue) => {
  handlefromdate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate
    }
    helperText={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate &&
      formik?.errors?.fromdate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="To Date"
  value={formik?.values?.todate || ""}
  size="small"
  onChange={(newValue) => {
  handletodate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.todate &&
      formik?.touched?.todate
    }
    helperText={
      formik?.errors?.todate &&
      formik?.touched?.todate &&
      formik?.errors?.todate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={1} md={1} lg={1} xl={1} className={classes.Endbtn}>
    <Button variant="contained" onClick={formik?.handleSubmit}>
      Filter
    </Button>
</Grid>
<Grid item xs={1} md={1} lg={1} xl={1} className={classes.Endbtn}>
    <Button variant="contained" onClick={()=>{navigate('/dashboard')}}>
      Dashboard
    </Button>
</Grid>

</Grid>

<Grid item xs={12}>
    <section className={classes.dataGridTable}>
<Box p={2}>
      {/* Search Bar */}
      <TextField
        label="Search..."
        variant="outlined"
        size="small"
        placeholder="Search"
        fullWidth
        margin="normal"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }} 
      />
</Box>
<Box sx={{ width: "100%", overflowX: "auto" }}>
    <DataTable
        columns={columns}
        data={filteredData}
        noDataComponent={null}
        pagination
        paginationServer
        paginationTotalRows={totalPages}
        paginationPerPage={pageSize}
        paginationComponentOptions={{ rowsPerPageText: "Rows per page:" }}
        onChangePage={(newPage) => setPage(newPage)}
        onChangeRowsPerPage={(newPageSize) => setPageSize(newPageSize)}
        highlightOnHover
        fixedHeader={true}
        fixedHeaderScrollHeight={"440px"}
        responsive
        customStyles={{
          headRow: {
            style: {
              fontWeight: "bold",
              fontSize: "13px",
              backgroundColor: "#f5f5f5",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap"
            },
          },
          headCells: {
            wrap:true,
            style: {
              fontWeight: "bold",
              fontSize: "13px",
              paddingRight:"0px",
              paddingLeft:"0px",
              justifyContent:"space-around"
            },
          },
          cells: {
            style: {
              whiteSpace: "normal",
              fontSize: "12px",
              wordWrap: "break-word"
            },
          },
        }}
        striped
      />
      </Box>

    </section>
</Grid>

</Grid>
</div>

    <Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
      ></Passengerhistorydetails>
          <Cancelcurrentride
        openDialog={cancelridemodel}
        id={requestId}
        handleClose={handlecloseCancelModel}
      ></Cancelcurrentride>
    </>
  );
};

export default Passenger;
